import { useEffect, useState } from 'react';
import { ITab } from '../../@types/interface';
import DescriptionTab from '../../components/Tab/description_tab';
import ProductTab from '../../components/Tab/product_tab';
import ShopTab from '../../components/Tab/shop_tab';

const Tab: React.FC<ITab> = ({activeTabShop, detailSP, date, moment, onChangeAttribute, onChangeAccessorieAmount, loadingStock }) => {
    let [activeIndex, setActiveIndex] = useState<number>(-1);
    let [tabs, setTabs] = useState([
        {
            index: 0,
            label: "Sản phẩm",
            hidden: ""
        },
        {
            index: 1,
            label: "Mô tả",
            hidden: ""
        },
        {
            index: 2,
            label: "Thông tin chi nhánh",
            hidden: ""
        }
    ]);
    

    useEffect(function(){
        let tabActive = 0;
        let arr_tabs = [...tabs];
        if (detailSP?.data?.is_product === false ? false : detailSP?.selectProductDetail?.is_set === false) {
            arr_tabs[0].hidden = " hidden";
            tabActive = 1;
            // [
            //     {
            //         index: 1,
            //         label: "Mô tả"
            //     },
            //     {
            //         index: 2,
            //         label: "Thông tin chi nhánh"
            //     }
            // ];
        }
        if (!detailSP?.data?.description) {
            // tabs = tabs.filter((e: any) => e.label !== "Mô tả");
            arr_tabs[1].hidden = " hidden";
            tabActive = (tabActive == 1 ? 2 : 0);
        }
        if(activeIndex==-1){
            setActiveIndex(tabActive);
        }
        else
            if(activeTabShop > 0){
                setActiveIndex(2);
            }
        setTabs(arr_tabs);
    }, [activeTabShop]);

    return <>
    <div className="product_tabs">
        <div className="product_tabs_heads ml-3 md:ml-[24px] justify-between">
            <div className="product_tabs_head">
                {
                    tabs?.map((tab: any, index: number) => {
                        return <div
                            key={tab.index}
                            onClick={() => { 
                                setActiveIndex(tab.index) 
                            }}
                            className={"product_tabs_head--tab " + (activeIndex === tab.index ? "active text-[#08979C]" : "text-[#8c8c8c]") + tab.hidden}>
                            <div className="pb-[16px]">
                                {tab.label}
                            </div>
                        </div>
                    })
                }
            </div>
            {/* <Image
                src={"/asset/icon/ico_question.svg"}
                alt="arrow_right"
                width={16}
                height={16}
            /> */}
        </div>
        {
            !detailSP?.data?.description && activeIndex == 0 && tabs.length > 0 &&
            <div className='product_tabs_caution pl-3 md:pl-[24px]'>
                <p className='break_2'>Lưu ý: Màu sắc có thể đậm/nhạt đôi chút do sự can thiệp ánh sáng khi chụp</p>
            </div>
        }
        
        {/* <div className="product_tabs_content">

        </div> */}
    </div>
    {
        <>
            <ProductTab
                    is_product={detailSP?.data?.is_product}
                    onChange={onChangeAccessorieAmount}
                    attribute={detailSP?.data?.attribute}
                    accessories={detailSP?.accessories}
                    handleChangeActive={onChangeAttribute}
                    key={"productTab"} hidden={activeIndex!==0}/>
            <DescriptionTab content={detailSP?.data?.description ?? ""} key={"contentTab"} hidden={activeIndex!==1}/>
            <ShopTab detail={detailSP} date={date} moment={moment} hidden={activeIndex!==2} key={"shopTap"} 
            loadingStock={loadingStock}/>
        </>
    }
    </>
}

export default Tab;